import type {Repository} from '@github-ui/current-repository'

export type Subject = {
  subjectDigest: string
  subjectName: string
}

type CertificateSummary = {
  buildConfigDisplayName: string
  resolvedBuildConfigUri: string
  resolvedSourceRepositoryCommitUri: string
  buildConfigDigest: string
  buildConfigUri: string
  buildSignerDigest: string
  buildSignerUri: string
  buildTrigger: string
  issuer: string
  runInvocationUri: string
  runnerEnvironment: string
  sourceRepositoryDigest: string
  sourceRepositoryIdentifier: string
  sourceRepositoryOwnerIdentifier: string
  sourceRepositoryOwnerUri: string
  sourceRepositoryRef: string
  sourceRepositoryUri: string
  sourceRepositoryVisibilityAtSigning: string
}

export type Attestation = {
  id: string
  predicateType: string
  subjectsCount: number
  bundle?: object
  createdAt: string
  subjects: Subject[]
} & CertificateSummary

export type PageInfo = {
  hasNextPage: boolean
  hasPreviousPage: boolean
  endCursor: string
  startCursor: string
}

export type AttestationsPayload = {
  repo: Repository
  attestations: Attestation[]
  pageInfo: PageInfo
  feedbackUrl: string
  totalCount: number
}

export type AttestationPayload = {
  repo: Repository
  attestation: Attestation
  rawLines: string[]
}

export const SortOrder = {
  Oldest: 1,
  Newest: 2,
} as const

export type SortOrderType = (typeof SortOrder)[keyof typeof SortOrder]
